import { render, staticRenderFns } from "./Superchat.vue?vue&type=template&id=80b7e8da&scoped=true&"
import script from "./Superchat.vue?vue&type=script&lang=js&"
export * from "./Superchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7e8da",
  null
  
)

export default component.exports